import { useQuery } from '@tanstack/react-query'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { getListBerthsByTenantEndpoint } from 'repositories/BerthApi/getListBerthsByTenant/endpoint'
import { GetListBerthsByTenantResponse } from 'repositories/BerthApi/getListBerthsByTenant/type'
import { berthKeys } from 'repositories/queryKeys'

import type { Berth } from '../types'

export function useListBerthsByTenant(tenantId: string | null, warehouseId: string | null) {
  const key = tenantId && warehouseId ? getListBerthsByTenantEndpoint(tenantId, warehouseId) : null

  const { data, error, isLoading } = useQuery<GetListBerthsByTenantResponse>({
    queryKey: berthKeys.list(tenantId ?? '', warehouseId ?? ''),
    queryFn: () => fetcher(key!),
    enabled: !!key,
  })

  const berths: Berth[] = (data?.data ?? []).map((b, index) => ({
    id: b.id?.toString() ?? '',
    name: b.name ?? '',
    group: null,
    order: index,
  }))

  return {
    berths,
    isLoading,
    error,
  }
}
